import { useCallback, useState } from "react";
import { useLocation } from "react-router";

import { getExpandedItems } from "../helpers";
import { useRedirect } from "../hooks";

import { LinkList } from "./LinkList";

import { SidebarItem } from "@/layouts/types";

export interface SidebarListProps {
  sidebarItems: SidebarItem[];
  shouldRedirectOnMount?: boolean;
}

export function SidebarList({ sidebarItems, shouldRedirectOnMount }: SidebarListProps) {
  const location = useLocation();
  useRedirect({ sidebarItems, shouldRedirectOnMount });

  const flatSidebarItems = Object.values(sidebarItems).flat();
  const [expandedItems, setExpandedItems] = useState<string[]>(getExpandedItems(flatSidebarItems, location.pathname));

  const handleSubNavClick = useCallback(
    (key: string) => {
      if (expandedItems.includes(key)) {
        setExpandedItems((prevState) => prevState.filter((item) => item !== key));
      } else {
        setExpandedItems((prevState) => [...prevState, key]);
      }
    },
    [expandedItems]
  );

  return (
    <>
      {sidebarItems.map((item) => (
        <LinkList
          item={item}
          key={item.identifier}
          label={item.label}
          secondaryLabel={item.secondaryLabel}
          items={item.subItems || []}
          expandedItems={expandedItems}
          handleSubNavClick={handleSubNavClick}
        />
      ))}
    </>
  );
}
